type Callback = (...args: any[]) => Promise<any>;

export const timeoutable: CurriedFn2<number, Callback, Callback> = (
  delayMS: number,
  callback?: Callback
) => {
  if (!callback) return timeoutable.bind(null, delayMS);

  return (...args: any[]) => {
    return new Promise((resolve, reject) => {
      let isOver = false;

      const onOver = (cb: (...args: any[]) => void) => (...args: any[]) => {
        if (isOver) return;
        isOver = true;
        cb(...args);
      };

      callback(...args)
        .then(onOver(resolve))
        .catch(onOver(reject));

      setTimeout(onOver(() => reject(Error('Timed out'))), delayMS);
    });
  };
};



// WEBPACK FOOTER //
// ./src/utils/timeoutable/timeoutable.ts